// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-icon-large[data-v-bbca6438]{font-size:2.8rem!important}", ""]);
// Exports
module.exports = exports;
